import logo from './logo.svg';
import './App.css';
import InteractionPage from './InteractionPage';
import Testimonials from './Testimonials';
import TestimonialsTemp from './TestimonialsTemp';
import 'bootstrap/dist/css/bootstrap.css';
// import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Routes, Route, Outlet, Link } from "react-router-dom";
import Header from './components/Header';
import MainPage from './MainPage';
import PamDemo from './pam/PamDemo';
import DlpDemo from './dlp/DlpDemo';
import CasBDemo from './CasB/CasBDemo';
import MdmDemo from './mdm/MdmDemo';
import MdmAndroidDemo from './mdm/MdmAndroidDemo';
import MdmIosDemo from './mdm/MdmIosDemo';
import MdmWindowsDemo from './mdm/MdmWindowsDemo';
import WpDemo from './wordpress/wpdemo';
import WordPressMain from './wordpress/WordPressMain';
import Saml from './wordpress/saml/Saml';
import CommonDemoPage from './wordpress/CommonPage';
import CommonCasBDemoPage from './CasB/CommonPage';
import { ldapData } from './wordpress/ldap';
import { webData } from './wordpress/web3';
import { wpidpData } from './wordpress/wpidp';
import { sharepointData } from './wordpress/sharepoint';
import { salesforceData } from './wordpress/salesforce';
import { powerbiData } from './wordpress/powerbi';
import { entraData } from './wordpress/entraid';
import { dcrmData } from './wordpress/dcrm';
import { proctoData } from './wordpress/proctopress';
import { restData } from './wordpress/restapi';
import { aiGovernData } from './wordpress/aiGovern';
import { mfaData } from './wordpress/mfa';
import SsoTemp from './wordpress/saml/SsoTemp';
import { outlookData } from './wordpress/outlook';
import { webAgencyData } from './wordpress/webAgency';
import {googleData} from './CasB/google';
import {msOData} from './CasB/msO';
import {shopifyData} from './CasB/shopify';
import CasBMain from './CasB/CasBMain';
import { IamPage } from './iam/IamPage';
import { DrupalDemoPage } from './drupal/DrupalDemoPage';
import { AtlassianDemoPage } from './atlassian/AtlassianDemoPage';
import { webHostingData } from './wordpress/webHosting';
import { aiAgentStudioData } from './wordpress/aiAgent';

function App() {
  return (

    <Routes>

      <Route path="/"
        element={
          <>
            <Header />
            <MainPage />
          </>
        } />

      <Route path="demo"
        element={
          <>
            <Header />
            <MainPage />
          </>
        } />

      <Route path="demo/iam"
        element={
          <>
            <Header />
            <IamPage />

          </>
        } />

      <Route path="demo/pam"
        element={
          <>
            <Header />
            <PamDemo />
          </>
        } />
        <Route path="demo/drupal"
        element={
          <>
            <Header />
            <DrupalDemoPage />
          </>
        } />
        <Route path="demo/atlassian"
        element={
          <>
            <Header />
            <AtlassianDemoPage />
          </>
        } />
      <Route path="demo/dlp"
        element={
          <>
            <Header />
            <DlpDemo />
          </>
        } />
      <Route path="demo/casb"
        element={
          <>
            <Header />
            <CasBMain />
          </>
        } />
        <Route path="demo/mdm"
        element={
          <>
            <Header />
            <MdmDemo />
          </>
        } />
        <Route path="demo/mdm/android"
        element={
          <>
            <Header />
            <MdmAndroidDemo />
          </>
        } />
        <Route path="demo/mdm/ios"
        element={
          <>
            <Header />
            <MdmIosDemo />
          </>
        } />
        <Route path="demo/mdm/windows"
        element={
          <>
            <Header />
            <MdmWindowsDemo />
          </>
        } />
        <Route path="demo/wp"
        element={
          <>
            <Header />
            <WordPressMain />
          </>
        } />
        <Route path="demo/wp/sso"
        element={
          <>
            <Header />
            <SsoTemp />
          </>
        } />
        <Route path="demo/wp/wpidp"
        element={
          <>
            <Header />
            <CommonDemoPage
            title="WordPress as IDP"
            subtext=""
            videoId="R40as235Vxk?si=Pqahp6uhzXlS-ihj"
            data={wpidpData} />
          </>
        } />
        <Route path="demo/wp/ldap"
        element={
          <>
            <Header />
            <CommonDemoPage
            title="LDAP/AD Integration for WordPress Sites"
            subtext=""
            videoId="O4FKNvgJpbY"
            data={ldapData} />
          </>
        } />
        <Route path="demo/wp/mfa"
        element={
          <>
            <Header />
            <CommonDemoPage
            title="Setup 2FA Verification for WordPress Sites"
            subtext=""
            videoId="mftn-shZx1U"
            data={mfaData} />
          </>
        } />
        <Route path="demo/wp/sharepoint"
        element={
          <>
            <Header />
            <CommonDemoPage
            title="SharePoint / OneDrive"
            subtext=""
            videoId="fZnU3e4vEgs"
            data={sharepointData} />
          </>
        } />
        <Route path="demo/wp/salesforce"
        element={
          <>
            <Header />
            <CommonDemoPage
            title="Salesforce Object Synchronization"
            subtext=""
            videoId="Rrda9VsF0EE"
            data={salesforceData} />
          </>
        } />
        <Route path="demo/wp/powerbi"
        element={
          <>
            <Header />
            <CommonDemoPage
            title="Power BI Integration"
            subtext=""
            videoId="FNhbdsRQnqo"
            data={powerbiData} />
          </>
        } />
        <Route path="demo/wp/aiGovern"
        element={
          <>
            <Header />
            <CommonDemoPage
            title="MCP Server for WordPress with AI Policy Enforcement"
            subtext="Secure MCP Server for WordPress | MCP Server Plugin | AI Governance for WordPress"
            videoId="PKqo4rUq9o0"
            data={aiGovernData} />
          </>
        } />

        <Route path="demo/wp/entra"
        element={
          <>
            <Header />
            <CommonDemoPage
            title="Entra ID / Azure B2C User Provisioning"
            subtext=""
            videoId="I5ZlI9Vwudk"
            data={entraData} />
          </>
        } />
        <Route path="demo/wp/dcrm"
        element={
          <>
            <Header />
            <CommonDemoPage
            title="Dynamics CRM Integration"
            subtext=""
            videoId="DMYHuYUTySE"
            data={dcrmData} />
          </>
        } />
        <Route path="demo/wp/outlook"
        element={
          <>
            <Header />
            <CommonDemoPage
            title="MS Outlook Integration"
            subtext=""
            videoId="Ngp5Av4i1ZU"
            data={outlookData} />
          </>
        } />
<Route path="demo/wp/webhosting"
        element={
          <>
            <Header />
            <CommonDemoPage
            title="miniOrange Web Hosting for WordPress"
            subtext="Experience Unmatched Performance and Security with miniOrange Web Hosting for WordPress"
            videoId="DyiekHMfsW4"
            data={webHostingData} />
          </>
        } />
        <Route path="demo/wp/ai-agent-studio"
        element={
          <>
            <Header />
            <CommonDemoPage
            title="AI Agent Studio Demo"
            subtext="Experience the Future of AI with miniOrange's AI Agent Studio Demo"
            videoId="4biAugvxR0o"
            data={aiAgentStudioData} />
          </>
        } />

        <Route path="demo/wp/web3"
        element={
          <>
            <Header />
            <CommonDemoPage
            title= "Secure web3login into your WordPress website with crypto wallets"
            subtext=" Unlock the Future of Digital Identity with Our Web3 Plugin!"
            videoId= "7XZ501n-OBM"
            data={webData} />
          </>
        } />
        <Route path="demo/wp/restapi"
        element={
          <>
            <Header />
            <CommonDemoPage
            title="WordPress REST API Authentication"
            subtext=""
            videoId="KCSN66b3AqE"
            data={restData} />
          </>
        } />
        <Route path="demo/wp/procto"
        element={
          <>
            <Header />
            <CommonDemoPage
            title="Comprehensive Proctoring Solution"
            subtext="Online Proctoring Solution for WordPress"
            videoId="lcw-uZlm4w0"
            data={proctoData} />
          </>
        } />
        <Route path="demo/wp/webagency"
        element={
          <>
            <Header />
            <CommonDemoPage
            title="Management Tool for Web Agency"
            subtext="Unlock Growth Potential for Your Web Agency"
            videoId="DT5z93cIvzE"
            data={webAgencyData} />
          </>
        } />

      <Route path="demo/casb/google"
              element={
                <>
                  <Header />
                  <CommonCasBDemoPage
                  title="Configure Policy and group for applying restriction using CASB"
                  subtext=""
                  videoId="mFIIdl-stDA"
                  data={googleData} />
                </>
              } />

        <Route path="demo/casb/office365"
              element={
                <>
                  <Header />
                  <CommonCasBDemoPage
                  title="Configure Policy and group for applying restriction using CASB"
                  subtext=""
                  videoId="mFIIdl-stDA"
                  data={msOData} />
                </>
              } />

    <Route path="demo/casb/shopify"
              element={
                <>
                  <Header />
                  <CommonCasBDemoPage
                  title="Configure Policy and group for applying restriction using CASB"
                  subtext=""
                  videoId="mFIIdl-stDA"
                  data={shopifyData} />
                </>
              } />

      <Route path="testimonials"
        element={
          <>
            <Header />
            <TestimonialsTemp />
          </>
        } />
    </Routes>


    // <InteractionPage/>
  );
}

export default App;
